import React from "react";
import ModalWrapper, { ModalContent } from "./ModalWrapper";

const Dialog = React.forwardRef(({
  elevation,
  elevated,
  size,
  fullScreen,
  noPadding,
  className,
  style,
  children,
  ...rest
}, ref) => {
  const classes = [
    "ta-dialog",
    elevation && "ta-elevation--shadow ta-elevation_" + elevation,
    !noPadding && !fullScreen && "ta-padding_s",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <ModalWrapper {...rest}>
      <div
        ref={ref}
        className={classes}
        style={{ ...style }}
        data-elevated={elevated || undefined}
        data-size={size || undefined}
        data-fullscreen={fullScreen ? "true" : undefined}
        data-slide={typeof fullScreen === "string" ? fullScreen.replace("slideFrom", "from") : undefined}
      >
        <ModalContent>{children}</ModalContent>
      </div>
    </ModalWrapper>
  );
});

export default Dialog;
